import React from 'react';
import PropTypes from 'prop-types';
import BaseDropdown from '../BaseDropdown';
const SpCustomerTypeDropdown = ({ keyId, handleChange, selectedId }) => {
  return (
    <>
      <BaseDropdown
        sources={[
          {
            id: -1,
            display: '-- All --'
          },
          {
            id: 0,
            display: 'Prospect Customer'
          },
          {
            id: 1,
            display: 'New Customer'
          },
          {
            id: 2,
            display: 'Old Customer'
          }
        ]}
        selectedOptions={selectedId}
        handleChange={opts => handleChange(keyId, opts)}
        isMulti={false}
      />
    </>
  );
};

SpCustomerTypeDropdown.propTypes = {
  collapseValues: PropTypes.bool,
  keyId: PropTypes.string,
  handleChange: PropTypes.func,
  selectedId: PropTypes.string,
};

export default SpCustomerTypeDropdown;
